const pjson = require('../package.json')
const ENV = 'development'

const TITLE = 'esel.ac - Free, communal bikesharing in Aachen.'
const NAME = 'esel.ac'
const SYSTEM_URL = 'https://di.esel.ac'
const API_ROOT = SYSTEM_URL + '/api'
const GBFS_URL = SYSTEM_URL + '/gbfs/gbfs.json'

const DEFAULT_LOCATION = [6.0839, 50.7753]
const DEFAULT_ZOOM = 13
const APP_VERSION = pjson.version

const I18N_MESSAGE_OVERRIDE = {
  de: {
    message: {
      about: {
        html: 'Kostenloses Bikesharing in Aachen'
      }
    }
  },
  en: {
    message: {
      about: {
        html: 'Free Bikesharing in Aachen'
      }
    }
  }
}

const SUPPORT_TYPE = ''
const SUPPORT_URL = ''

const SENTRY_DSN = ''
const TEST_USER = ''
// TEST_USER = 'Linus.WhatThe.Heck'

module.exports = { ENV, TITLE, NAME, API_ROOT, APP_VERSION, GBFS_URL, DEFAULT_LOCATION, DEFAULT_ZOOM, I18N_MESSAGE_OVERRIDE, SUPPORT_TYPE, SUPPORT_URL, SYSTEM_URL, SENTRY_DSN, TEST_USER }
